module.exports = __webpack_public_path__ + "static/media/kendrafoundit-IG-8.c86fb518.PNG";